module.exports = __webpack_public_path__ + "img/login-account-provider.af5cc358.png";